/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import borders from "assets/theme/theme-light/base/borders";
import colors from "assets/theme/theme-light/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;
const { white, green } = colors;

const linearProgress = {
  styleOverrides: {
    root: {
      height: pxToRem(8),
      borderRadius: borderRadius.sm,
      overflow: "hidden",
      position: "relative",
    },

    colorPrimary: {
      backgroundColor: white.main,
    },

    colorSecondary: {
      backgroundColor: green.state,
    },

    bar: {
      height: pxToRem(8),
      backgroundColor: green.state,
      borderRadius: borderRadius.xs,
      position: "absolute",
      transform: `translate(0, 100) !important`,
      transition: "width 0.4s ease !important",
    },
  },
};

export default linearProgress;
